(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddConditionableQuestion', directive);

    directive.$inject = ['oddQuestionnaireTemplateService', 'modalService'];

    function directive(oddQuestionnaireTemplateService, modalService) {
        return {
            restrict: 'E',
            scope: {
                question: '=',
                section: '=',
                isDisabled: '=',
                required: '&'
            },
            require: ['^form'],
            templateUrl: require('./oddConditionableQuestion.tpl.html'),
            link: function ($scope, $element, $attrs, $ctrl) {
                $scope.form = $ctrl[0];
                $scope.validate();
            },
            controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
                $scope.required = $scope.required();
                $scope.style = {};

                $scope.add = add;
                $scope.remove = remove;
                $scope.validate = validate;

                function validate() {
                    if ($scope.required) {
                        $scope.form.$setValidity('ConditionalODDQuestion', !!$scope.question.ConditionalODDQuestionID);
                    }
                }

                function add(selectedQuestion) {
                    var promise;

                    if ($scope.question.ODDQuestionID) {
                        promise = oddQuestionnaireTemplateService.getConditionableQuestions(
                            $scope.section.ODDBusinessUnitID,
                            $scope.section.ODDQuestionnaireID,
                            $scope.section.ODDSectionID,
                            $scope.question.ODDQuestionID);
                    } else {
                        promise = oddQuestionnaireTemplateService.getConditionableQuestionsBySection(
                            $scope.section.ODDBusinessUnitID,
                            $scope.section.ODDQuestionnaireID,
                            $scope.section.ODDSectionID)
                    }

                    // Fetch types
                    promise.then(function (conditionableQuestions) {
                        var modal = modalService.displayTemplateModal(
                            'Select a Question',
                            require('./oddConditionableQuestion.modal.tpl.html'),
                            {
                                questions: conditionableQuestions.ConditionableODDQuestions,
                                ctrl: { selectedQuestion: selectedQuestion },
                                classes: 'modal-lg',
                                onQuestionSelection: function(ctrl, question) {
                                    modal.$scope.title = 'Select a choice';
                                    ctrl.selectedQuestion = question;
                                },
                                onChoiceSelection: function(ctrl, choice) {
                                    _add(ctrl.selectedQuestion, choice);
                                    modal.hide();
                                }
                            },
                            false
                        )
                    });
                }

                function _add(question, choice) {
                    $scope.question.ConditionalODDQuestionID = question.ODDQuestionID;
                    $scope.question.ConditionalODDQuestion = question;
                    $scope.question.ConditionalODDQuestionChoiceID = choice.ODDQuestionChoiceID;
                    $scope.question.ConditionalODDQuestionChoice = choice;
                    $scope.form.$setDirty();
                }

                function remove() {
                    delete $scope.question.ConditionalODDQuestionID;
                    delete $scope.question.ConditionalODDQuestion;
                    delete $scope.question.ConditionalODDQuestionChoiceID;
                    delete $scope.question.ConditionalODDQuestionChoice;
                    $scope.form.$setDirty();
                }
            }]
        }
    }
})();
